import React, { useState, useRef } from 'react'

// styles
import { WrapPopupStyles } from '../WrapPopupStyles'
import { WrapQueryByBioImage } from './index.styles'

// image
import icCloseGray from '../../../../../images/ic_close_gray.svg'

// component
import FaceQuery from './FaceQuery'
import FingerQuery from './FingerQuery'

// hooks
import useMoveElement from '../../../../../helper/Hooks/useMoveElement'

const QueryByBioImage = ({ handleClose }) => {

    const queryByBioImageRef = useRef(null)

    const [loadingQueryByFace, setLoadingQueryByFace] = useState(false);
    const [loadingQueryByFinger, setLoadingQueryByFinger] = useState(false);
    const [error, setError] = useState('');

    useMoveElement(queryByBioImageRef, ".title")

    return (
        <WrapPopupStyles>
            <WrapQueryByBioImage ref={queryByBioImageRef}>
                <div className="title">Vấn tin sinh trắc học</div>
                <img className="ic-close" src={icCloseGray} alt="close" onClick={handleClose} />
                <div className="content">
                    <FaceQuery
                        loadingQueryByFinger={loadingQueryByFinger}
                        setLoadingQueryByFace={setLoadingQueryByFace}
                        setError={setError}
                    />
                    <FingerQuery
                        loadingQueryByFace={loadingQueryByFace}
                        setLoadingQueryByFinger={setLoadingQueryByFinger}
                        setError={setError}
                    />
                </div>
                <div className="error">{error}</div>
            </WrapQueryByBioImage>
        </WrapPopupStyles>
    )
}

export default QueryByBioImage
